module.exports = __webpack_public_path__ + "img/logo.c5b293da.svg";